/** Strip leading @ characters from a social handle (API may return "@user" or "user"). */
export function stripLeadingAt(username?: string | null): string {
    if (username == null || username === '') return '';
    return String(username).trim().replace(/^@+/, '');
}

/** Display handle with a single leading @, e.g. "@creator". */
export function formatSocialHandle(username?: string | null, fallback = ''): string {
    const handle = stripLeadingAt(username);
    if (!handle) return fallback;
    return `@${handle}`;
}
